module.exports = __webpack_public_path__ + "img/Wien.a998dff3.jpg";